import httpClient from "../lib/HttpClient"

export const getCategoryOptionsByBranchHttp = async (branchId) => {
    return await httpClient.get(`option/category-by-branch?branchId=${branchId}`)
}
export const getSubcategoryOptionsHttp = async (id) => {
    return await httpClient.get(`option/subcategory?id=${id}`)
}
export const getBranchOptionsHttp = async (id) => {
    return await httpClient.get(`option/branch`)
}